<div class="image-container" [ngClass]="{'fill-container': fillContainer}">
  @if (imageUrl) {
    <img alt="" data-testing-id="screenshot-image-a" [ngClass]="{'loaded': isLoaded}" (error)="setError($event)" (load)="loaded()" [src]="imageUrl" />
  }
</div>
@if (!loaded) {
  <div class="loading">
    <p-progressSpinner></p-progressSpinner>
  </div>
}
@if (!loaded && !imageUrl) {
  <div class="no-image">
    <fa-icon [icon]="faImage"></fa-icon>
    <p>There is no screenshot available for this state: {{errorText}}</p>
  </div>
}

